
import Page from "./Page";


export default function Paginator({
	currentPage,
	maxPageNum,
	isLoading,
	onChange,
	scrollToTop = true,
	scrollAnchorRef,
}) {
	const scrollAfterPageChange = () => {
		if (scrollAnchorRef?.current) {
			scrollAnchorRef.current.scrollIntoView({
				behavior: "smooth",
				block: "start",
			});
			return;
		}
		if (scrollToTop) {
			window.scrollTo({ top: 0, behavior: "smooth" });
		}
	};

	const onClick = (pageNum) => {
		if (isLoading) {
			return;
		}
		if (pageNum === currentPage) {
			return;
		}
		if (pageNum < 1 || pageNum > maxPageNum) {
			return;
		}
		onChange(pageNum);
		scrollAfterPageChange();
	};

	function getFirstPageNums() {
		const pageNums = [];
		if (currentPage >= 3) {
			pageNums.push(1);
		}
		if (currentPage >= 4) {
			pageNums.push(2);
		}
		return pageNums;
	}

	function getLastPageNums() {
		const pageNums = [];
		if (currentPage <= maxPageNum - 3) {
			pageNums.push(maxPageNum - 1);
		}
		if (currentPage <= maxPageNum - 2) {
			pageNums.push(maxPageNum);
		}
		return pageNums;
	}

	function getMiddlePageNums() {
		const pageNums = [];
		if (currentPage >= 2) {
			pageNums.push(currentPage - 1);
		}
		pageNums.push(currentPage);
		if (currentPage <= maxPageNum - 1) {
			pageNums.push(currentPage + 1);
		}
		return pageNums;
	}

	function firstDeviderExist() {
		const firstPageNums = getFirstPageNums();
		const middlePageNums = getMiddlePageNums();
		if (
			firstPageNums.length > 0 &&
			middlePageNums.length > 0 &&
			firstPageNums[firstPageNums.length - 1] !== middlePageNums[0] - 1
		) {
			return true;
		}
		return false;
	}

	function lastDeviderExist() {
		const lastPageNums = getLastPageNums();
		const middlePageNums = getMiddlePageNums();
		if (
			lastPageNums.length > 0 &&
			middlePageNums.length > 0 &&
			lastPageNums[0] !== middlePageNums[middlePageNums.length - 1] + 1
		) {
			return true;
		}
		return false;
	}

	const renderDivider = (key) => (
		<div
			key={key}
			className="flex flex-row items-center px-1"
			aria-hidden
		>
			<div className="h-[5px] w-[5px] rounded-full bg-[#888888]" />
			<div className="w-[4px]" />
			<div className="h-[5px] w-[5px] rounded-full bg-[#888888]" />
			<div className="w-[4px]" />
			<div className="h-[5px] w-[5px] rounded-full bg-[#888888]" />
		</div>
	);

	return (
		<nav
			dir="rtl"
			className="flex flex-row flex-wrap items-center justify-center gap-1"
			aria-label="صفحه‌بندی"
		>
			{getFirstPageNums().map((page) => (
				<button
					key={`first-${page}`}
					type="button"
					className="border-0 bg-transparent p-1.5"
					onClick={() => onClick(page)}
					disabled={isLoading}
					aria-current={page === currentPage ? "page" : undefined}
				>
					<Page pageNum={page} isSelected={page === currentPage} />
				</button>
			))}
			{firstDeviderExist() && renderDivider("first")}
			{getMiddlePageNums().map((page) => (
				<button
					key={`mid-${page}`}
					type="button"
					className="border-0 bg-transparent p-1.5"
					onClick={() => onClick(page)}
					disabled={isLoading}
					aria-current={page === currentPage ? "page" : undefined}
				>
					<Page pageNum={page} isSelected={page === currentPage} />
				</button>
			))}
			{lastDeviderExist() && renderDivider("last")}
			{getLastPageNums().map((page) => (
				<button
					key={`last-${page}`}
					type="button"
					className="border-0 bg-transparent p-1.5"
					onClick={() => onClick(page)}
					disabled={isLoading}
					aria-current={page === currentPage ? "page" : undefined}
				>
					<Page pageNum={page} isSelected={page === currentPage} />
				</button>
			))}
		</nav>
	);
}
